import { render, staticRenderFns } from "./EnacAtplDashboardRegistrationTopBox.vue?vue&type=template&id=62f8e74a"
import script from "./EnacAtplDashboardRegistrationTopBox.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardRegistrationTopBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports